import api from './api';

const projectBudgetService = {
  // Listar itens de orçamento de um projeto
  getBudgetItems: async (projectId) => {
    const response = await api.get(`/projects/${projectId}/budget`);
    return response.data;
  },

  // Criar novo item de orçamento
  createBudgetItem: async (projectId, itemData) => {
    const response = await api.post(`/projects/${projectId}/budget`, itemData);
    return response.data;
  },

  // Atualizar item de orçamento
  updateBudgetItem: async (projectId, itemId, itemData) => {
    const response = await api.put(`/projects/${projectId}/budget/${itemId}`, itemData);
    return response.data;
  },

  // Deletar item de orçamento
  deleteBudgetItem: async (projectId, itemId) => {
    const response = await api.delete(`/projects/${projectId}/budget/${itemId}`);
    return response.data;
  },

  // Formatar valores monetários
  formatCurrency: (value) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(value || 0);
  },

  // Análise Inteligente
  uploadExcelAnalysis: async (projectId, file) => {
    const formData = new FormData();
    formData.append('excelFile', file);
    
    const response = await api.post(`/projects/${projectId}/budget/analyze`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  getAnalysis: async (projectId) => {
    const response = await api.get(`/projects/${projectId}/budget/analysis`);
    return response.data;
  },

  // Montar orçamento final
  buildBudget: async (projectId, data = {}) => {
    const response = await api.post(`/projects/${projectId}/budget/build`, data);
    return response.data;
  },

  // Download PDFs
  downloadManagerPDF: async (projectId, filename) => {
    try {
      const response = await api.get(`/projects/${projectId}/budget/pdf/manager`, {
        params: { file: filename },
        responseType: 'blob'
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao baixar PDF gerente:', error);
      throw error;
    }
  },

  downloadClientPDF: async (projectId, filename) => {
    try {
      const response = await api.get(`/projects/${projectId}/budget/pdf/client`, {
        params: { file: filename },
        responseType: 'blob'
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao baixar PDF cliente:', error);
      throw error;
    }
  }
};

export default projectBudgetService;
